import React from 'react'
import {SelectedCard} from "./SelectedCard";
import {formattedDateTime} from "../../services/date";
import {getEventCardFooter, type EntityItem} from "./EntitySelectorModal.helpers";
import {ENTITY_TYPES} from "../EntitySelector/EntitySelector.constants";
import {type EntityType, type SelectedItem as Item} from "../EntitySelector/EntitySelector.types";

// Types ----

type SelectedItemProps = {
  entity: EntityItem
  onRemoveItem: <K extends EntityType>(item: Item<K>, entityType: K) => void
  isMultiSite?: boolean
}

// Component ----

function SelectedItem({ entity, onRemoveItem, isMultiSite = false }: SelectedItemProps) {
  return (
    <>
      {entity.type === ENTITY_TYPES.ACHIEVEMENT &&
        <SelectedCard
          key={`achievement-${entity.item.id}`}
          heading={entity.item.name}
          footer={entity.item.description}
          onRemove={() => onRemoveItem(entity.item, ENTITY_TYPES.ACHIEVEMENT)}
          imageUrl={entity.item.image?.preview_url}
        />
      }

      {entity.type === ENTITY_TYPES.ARTICLE &&
        <SelectedCard
          key={`article-${entity.item.id}`}
          heading={entity.item.title}
          footer={entity.item.excerpt}
          onRemove={() => onRemoveItem(entity.item, ENTITY_TYPES.ARTICLE)}
          imageUrl={entity.item.image?.preview_url}
        />
      }

      {entity.type === ENTITY_TYPES.COLLECTION &&
        <SelectedCard
          key={`collection-${entity.item.id}`}
          heading={entity.item.name}
          footer={entity.item.location}
          onRemove={() => onRemoveItem(entity.item, ENTITY_TYPES.COLLECTION)}
          imageUrl={entity.item.images[0]?.preview_url}
        />
      }

      {entity.type === ENTITY_TYPES.EVENT &&
        <SelectedCard
          key={`event-${entity.item.id}`}
          heading={entity.item.name}
          subheading={formattedDateTime(entity.item.starts_at)}
          footer={getEventCardFooter(entity.item, isMultiSite)}
          onRemove={() => onRemoveItem(entity.item, ENTITY_TYPES.EVENT)}
          imageUrl={entity.item.image?.preview_url}
        />
      }

      {entity.type === ENTITY_TYPES.EXHIBIT &&
        <SelectedCard
          key={`exhibit-${entity.item.id}`}
          heading={entity.item.name}
          footer={isMultiSite ? entity.item.zone?.site?.name : null}
          onRemove={() => onRemoveItem(entity.item, ENTITY_TYPES.EXHIBIT)}
          imageUrl={entity.item.image?.preview_url}
        />
      }

      {entity.type === ENTITY_TYPES.FACILITY &&
        <SelectedCard
          key={`facility-${entity.item.id}`}
          heading={entity.item.name}
          footer={isMultiSite ? entity.item.zone?.site?.name : null}
          onRemove={() => onRemoveItem(entity.item, ENTITY_TYPES.FACILITY)}
          imageUrl={entity.item.image?.preview_url}
        />
      }

      {entity.type === ENTITY_TYPES.PLACE &&
        <SelectedCard
          key={`place-${entity.item.id}`}
          heading={entity.item.name}
          footer={entity.item.address?.city}
          onRemove={() => onRemoveItem(entity.item, ENTITY_TYPES.PLACE)}
        />
      }

      {entity.type === ENTITY_TYPES.QUIZ &&
        <SelectedCard
          key={`quiz-${entity.item.id}`}
          heading={entity.item.title}
          footer={entity.item.type.name}
          onRemove={() => onRemoveItem(entity.item, ENTITY_TYPES.QUIZ)}
          imageUrl={entity.item.image?.preview_url}
        />
      }

      {entity.type === ENTITY_TYPES.SITE &&
        <SelectedCard
          key={`site-${entity.item.id}`}
          heading={entity.item.name}
          footer={entity.item.address.city}
          onRemove={() => onRemoveItem(entity.item, ENTITY_TYPES.SITE)}
          imageUrl={entity.item.image?.preview_url}
        />
      }

      {entity.type === ENTITY_TYPES.ZONE &&
        <SelectedCard
          key={`zone-${entity.item.id}`}
          heading={entity.item.name}
          footer={isMultiSite ? entity.item.site.name : null}
          onRemove={() => onRemoveItem(entity.item, ENTITY_TYPES.ZONE)}
        />
      }
    </>
  );
}

export {SelectedItem};
